import { SalaryType } from '../../../../../../shared/util/salary/SalaryType';

/**
 * Pay bounds validation for different salary types
 * Based on onboarding MinimumPay validation patterns
 * Note: These are US pay bounds - for international support, consider using OneGraph validation
 */
export const payBounds = {
    [SalaryType.Hourly]: [2, 500],
    [SalaryType.Daily]: [30, 4000],
    [SalaryType.Weekly]: [40, 20000],
    [SalaryType.Monthly]: [100, 90000],
    [SalaryType.Yearly]: [2000, 1000000],
} as const;

export type PayBoundsKey = keyof typeof payBounds;
